import { Fragment } from 'react'
import { NextSeo } from 'next-seo'
import { useRouter } from 'next/router'
import { VStack, Grid, Box } from '@chakra-ui/react'

import NavigationBar from '@/components/organisms/NavigationBar'
import { Footer } from '@/components/organisms/Footer'

import CourseTitle from '@/features/Courses/templates/CourseTitle'
import CourseNavigation from '@/features/Courses/templates/CourseNavigation'
import CourseList from '@/features/Courses/templates/CourseList'
import CourseSticky from '@/features/Courses/templates/CourseSticky'
import { BundlePromoImage } from '@/features/Courses/components/StickyWidget'
import { LazySummary } from '@/features/Landing/containers/Summary'

import { TABS, COURSES } from '@/features/Courses/constants'
import { CourseContextProvider } from '@/features/Courses/contexts/CourseContext'
import { Course } from '@/features/Courses/types'

function CourseDetail(): React.ReactElement {
  const router = useRouter()

  const course = COURSES.find(
    (course) => course.slug === router.query.slug,
  ) as Course

  const title = course.metaTitle || course.title
  const description = course.metaDescription || course.description

  return (
    <Fragment>
      <NextSeo
        title={title}
        description={description}
        openGraph={{
          title: title,
          description: description,
          url: router.asPath,
          images: [
            {
              url: course.image,
              alt: course.metaTitle,
            },
          ],
        }}
      />
      <NavigationBar />
      <CourseContextProvider value={course}>
        <Box layerStyle="landingContainer">
          <Grid
            sx={{
              alignItems: 'stretch',
              gridGap: 4,
              gridTemplateColumns: { base: '1fr', md: '1fr 380px' },
            }}
          >
            <VStack
              as="main"
              id="course-container"
              sx={{
                position: 'relative',
                alignItems: 'stretch',
                maxW: {
                  base: 'full',
                  md: '713px',
                },
              }}
            >
              <CourseTitle />
              <CourseNavigation tabs={TABS} />
            </VStack>
            <Box
              sx={{
                display: {
                  base: 'none',
                  md: 'block',
                },
              }}
            >
              <CourseSticky />
            </Box>
          </Grid>
          {course.bundlePromoImage && (
            <Box
              sx={{
                display: {
                  base: 'block',
                  md: 'none',
                },
                mt: 14,
              }}
            >
              <BundlePromoImage course={course} />
            </Box>
          )}
          <CourseList courses={COURSES} />
        </Box>
      </CourseContextProvider>
      <LazySummary id="summary" />
      <Footer />
    </Fragment>
  )
}

export default CourseDetail
